<template>
  <BaseModule
    v-bind="$props"
    class="content-block"
    data-module="content-block"
  >
    <TextAndMedia v-bind="$props">
      <template #title>
        <component
          :is="titleTag"
          class="tit tit-g"
        >
          {{ title }}
        </component>
      </template>
    </TextAndMedia>
  </BaseModule>
</template>

<script>
import base from '@/mixins/base';
import BaseModule from './generic/BaseModule.vue';
import TextAndMedia from './generic/TextAndMedia.vue';

export default {
  name: 'ContentBlock',
  components: {
    BaseModule,
    TextAndMedia,
  },
  mixins: [base],
  inheritAttrs: false,
  props: {
    ...BaseModule.props,
    ...TextAndMedia.props,
  },
  metadata: {
    extends: [BaseModule.metadata, TextAndMedia.metadata],
  },
};
</script>

<style scoped lang="scss">
.content-block {
  &::v-deep {
    .texto {
      .links {
        .cta {
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
